module.exports = __webpack_public_path__ + "img/main-playnow.1528a393.png";